export default interface IStepperConfig {
  RequestAccess: string;
  EmailVerification: string;
  UserInfo: string;
  SelectCompany: string;
  BusinessInfo: string;
  Diversity: string;
  Products: string;
  Login: string;
}

export class StepperConfig implements IStepperConfig {
  RequestAccess: string;
  EmailVerification: string;
  UserInfo: string;
  SelectCompany: string;
  BusinessInfo: string;
  Diversity: string;
  Products: string;
  Login: string;

  constructor() {
    this.EmailVerification = 'EmailVerification';
    this.RequestAccess = 'RequestAccess';
    this.UserInfo = 'UserInfo';
    this.SelectCompany = 'SelectCompany';
    this.BusinessInfo = 'BusinessInfo';
    this.Diversity = 'Diversity';
    this.Products = 'Products';
    this.Login = 'Login';
  }
}
